import StoreSettingsPage from './detail/StoreSettingsPage';
import FaqTab from './detail/FaqTab';

export default function StoreFaq() {
	return (
		<StoreSettingsPage title='Store - FAQ'>
			{(store, setStore, headerActions) => <FaqTab storeId={store.storeId} headerActions={headerActions} />}
		</StoreSettingsPage>
	);
}
